import { h } from 'preact';
import * as BaseComp from 'components/bolt/hub/components/carousel/tile.js';
import { navigateInternally } from 'utils/bolt';
import Store from 'store/store';
import { fade } from 'utils/bolt/transitions';

export default class Tile extends BaseComp.default {
	async onTileClick(e, carouselTitle, tileTitle) {
		const path = this.props.data?.path;
		if (!path || !this.tile.contains(e.target) || this.buttons?.base?.contains(e.target)) {
			return;
		}

		const { activePage } = Store.get();
		const isSearchPage = activePage === 'search';

		Store.emit('CUSTOM_EVENT', {
			category: activePage.replace('Scroll', ''),
			action: (isSearchPage ? 'search' : carouselTitle) + '_tile-click_' + tileTitle,
			label: '-'
		});

		if (path.startsWith('http') || path.startsWith('mailto:')) {
			let link = document.createElement('a');
			link.href = path;
			link.target = '_blank';
			link.style.display = 'none';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} else {
			await fade(document.getElementById('mainScroll'), 'out', 500);
			navigateInternally(path);
			fade(document.getElementById('mainScroll'), 'in', 700);
		}
	}
}
